import React, { Dispatch } from 'react';
import { DropArea } from '../../../../../../../components/form/DropArea/DropArea';
import { ReactComponent as UploadBillIcon } from '../../../../../../../assets/billpay/upload-bill.svg';
import { ACCEPTED_BILL_TYPES, BILLS_STATUSES } from '../../../../../consts';
import { useUploadAttachment } from '../../../../../hooks/useUploadAttachment';
import { useStore } from '../../../../../../../store';
import { featureAccess, LimitedFeatureType } from '../../../../../../../services/appAccess.service';
import { FEATURE_FLAG } from '../../../../../../../constants/general';
import { FeatureAccess } from '../../../../../../AccountSettings/components/rolesAndPermissions/PermissionsList';

export const MAX_FILE_SIZE_MB = 15;

interface IProps {
  setUploadDone: Dispatch<React.SetStateAction<boolean | null>>;
  setDocumentIdFromResponse: Dispatch<React.SetStateAction<string>>;
}

const BillPreviewNoAttachment = ({ setUploadDone, setDocumentIdFromResponse }: IProps) => {
  const {
    mutation: { mutateAsync },
  } = useUploadAttachment();
  const selectedBill = useStore((state) => state.selectedBill);
  const setUpdatedUnpaidBillById = useStore((state) => state.setUpdatedUnpaidBillById);
  const setUpdatedPaidBillById = useStore((state) => state.setUpdatedPaidBillById);
  const billPayPermission = featureAccess(FEATURE_FLAG.BILL_PAY, LimitedFeatureType.BillPay);

  const handleDropAreaFiles = (filesList: FileList) => {
    const billId = selectedBill?.billId;
    const list = Array.from(filesList);
    const fileToUpload = list[0];
    mutateAsync({ file: fileToUpload, billId }).then((res) => {
      setUploadDone(true);
      const docId = res.documentId;
      setDocumentIdFromResponse(docId);
      if (
        selectedBill?.calculatedStatus === BILLS_STATUSES.PENDING ||
        selectedBill?.calculatedStatus === BILLS_STATUSES.AWAITING_DETAILS
      ) {
        if (selectedBill) setUpdatedUnpaidBillById(selectedBill.billId, docId);
      } else if (selectedBill) setUpdatedPaidBillById(selectedBill.billId, docId);
    });
  };
  return (
    <DropArea
      isDisabled={billPayPermission !== FeatureAccess.READ_WRITE}
      acceptedTypes={ACCEPTED_BILL_TYPES}
      onFilesChange={handleDropAreaFiles}
      IconAsProp={UploadBillIcon}
      maxFileSizeInMb={MAX_FILE_SIZE_MB}
    />
  );
};

export default BillPreviewNoAttachment;
